import type React from 'react';
import type {ClipType} from '../../../../../core/entities/clip/constants';
import type {UsersMeClipsResponse} from '../../../../../core/entities/clip/schema';
import {useInfiniteFilteredClips} from '../../../usecases/useInfiniteFilteredClips';
import {NoDataText} from '../../NoDataText';
import {ClipList} from '../ClipList';
import {ClipListForMobile} from '../ClipListForMobile';

export type IClipList = {
  clipType: ClipType;
};

type IClipListComponentProps = {
  clips: UsersMeClipsResponse['clips'];
  hasNextPage: boolean | undefined;
  isFetching: boolean;
  isFetchingNextPage: boolean;
  loadMoreClips: () => void;
};

const withClipListContainer = (
  Component: React.ComponentType<IClipListComponentProps>,
) => {
  return ({clipType}: IClipList) => {
    const {
      filteredClips,
      hasNextPage,
      isFetching,
      isFetchingNextPage,
      loadMoreClips,
    } = useInfiniteFilteredClips(clipType);

    if (!filteredClips || filteredClips.length === 0) {
      return <NoDataText />;
    }

    return (
      <Component
        clips={filteredClips}
        hasNextPage={hasNextPage}
        isFetching={isFetching}
        isFetchingNextPage={isFetchingNextPage}
        loadMoreClips={loadMoreClips}
      />
    );
  };
};

export const ClipListContainer = withClipListContainer(ClipList);
export const ClipListForMobileContainer =
  withClipListContainer(ClipListForMobile);
